import { useMutation, useQueryClient } from '@tanstack/react-query';

import { queryKeysSupplier } from '../queryKeys';

import { type UpdateSupplierContactMutationOptions } from './types';
import { updateSupplierContact } from './updateSupplierContact';

/**
 * React Query based custom hook for updating an existing contact of a supplier.
 *
 * Invalidates the supplier detail query for the affected data exchange ID on settle.
 *
 * @param options - Optional mutation options.
 * @returns The mutation result.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Supplier-details/operation/update_supplier_contact_suppliers_details__de_id__contacts__contact_id__patch
 */
export const useMutationUpdateSupplierContact = (
  options?: UpdateSupplierContactMutationOptions,
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ deId, contactId, payload }) =>
      updateSupplierContact(deId, contactId, payload),
    onSettled(_data, _error, { deId }) {
      void queryClient.invalidateQueries({
        queryKey: queryKeysSupplier.getDetail(deId),
      });
    },
    throwOnError: false,
    ...options,
  });
};
